<template>
  <MenuItem :data="diagnosisList" header="Motor"/>
</template>
<script>
import MenuItem from './components/MenuItem';
import { modelOpenRouter } from '@/mixins/model-open';

export default {
  name: 'DiagnosisMotor',
  mixins: [modelOpenRouter],
  components: {
    MenuItem
  },
  data () {
    return {
      diagnosisList: [
        {
          id: 'diagnosisMotor',
          img: 'item_part_motor.png',
          item: 'Motor',
          path: ''
        },
        {
          id: 'diagnosisBack',
          img: 'item_back.png',
          item: 'Back',
          path: '/service-tools/diagnosis'
        },
        {
          id: 'diagnosisFinishAndCreateReport',
          img: 'item_confirm.png',
          item: 'Finish and Create Report',
          path: 'confirm'
        }
      ]
    };
  }
};
</script>
<style lang="scss" scoped>
</style>
